import { Autocomplete, Checkbox, FormGroup, TextField, Tooltip } from "@mui/material";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import { getDecryptedToken } from "../../../../../../app/auth/authHandler";
import {
  getDeliveryInfoListAsync,
  selectedDeliverySlot,
  selectedDeliveryType,
  setPayButtonDisabled,
  setStepperActiveMenu,
  selectedDeliveryDate,
  selectedDeliveryInstructions,
  selectedPickupTime,
  setOptIn,
  getWhatsapCheckAsync,
} from "../../../../../../app/slices/checkoutSlice/CheckoutSlice";
import {
  setDeliveryAddressFlatNo as setDeliveryAddressFlatNoInStore,
  setDeliveryAddressLandmark as setDeliveryAddressLandmarkInStore,
} from "../../../../../../app/slices/checkoutSlice/CheckoutSlice";
import CustomButton from "../../../../../components/custom/button";
import CustomInput from "../../../../../components/custom/input";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React, { useEffect, useRef, useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import NearMeIcon from "@mui/icons-material/NearMe";
import AddIcon from "@mui/icons-material/Add";
import { getAddressListAsync } from "../../../../../../app/slices/addressSlice/ProfileSlice";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs/AdapterDayjs";
// import dayjs, { Dayjs } from "dayjs";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import {
  orderForSomeOneElseAsync,
  fetchCartListAsync,
  removeSomeOneElseAsync,
  setAdditionalInfo,
  setSomeOneElseOrder,
} from "../../../../../../app/slices/cartSlice/CartSlice";
import { showSnackbar } from "../../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import {
   MobileDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import Alert from '@mui/material/Alert';
import {SelectedAddressMobile} from "../SelectedAddressMobile";
import { useMediaQuery } from "@mui/material";
import { DeliverAddress } from "../deliveryAddress";
import CustomDialog from "../../../../../components/custom/dialog";
import { PaymentPage } from "../pay";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { DeliverySlotSelection } from "../../CheckoutTypes";

export const DeliveryInfo = () => {
  const isMobileScreen = useMediaQuery("(max-width:765px)");
  const dispatch = useAppDispatch();
  const [slotValue, setSlotValue] = useState<DeliverySlotSelection>({
    id: "",
    value: "",
  });
  const reduxSlotValue = useAppSelector(
    (state) => state.CheckoutState.selectedDeliverySlot
  );
  const reduxDeliveryType = useAppSelector(
    (state) => state.CheckoutState.selectedDeliveryType
  );
  const reduxDeliveryDate = useAppSelector(
    (state) => state.CheckoutState.selectedDeliveryDate
  );
  const reduxPickupTime = useAppSelector(
    (state) => state.CheckoutState.selectedPickupTime
  );
  const reduxFlatNo = useAppSelector(
    (state) => state.CheckoutState.deliveryAddressFlatNo
  );
  const reduxLandmark = useAppSelector(
    (state) => state.CheckoutState.deliveryAddressLandmark
  );
  const reduxDeliveryInstructions = useAppSelector(
    (state) => state.CheckoutState.selectedDeliveryInstructions
  );
  const deliveryInfoOptions = useAppSelector(
    (state) => state.CheckoutState.deliveryinfoList
  );
  const deliverySlots = (deliveryInfoOptions?.data as unknown as any[]) || [];
  const [selectedDate, setSelectedDate] = useState<any>("");
  const [selectedTime, setSelectedTime] = useState<any>(null);
  const [pickupDateTimePickerOpen, setPickupDateTimePickerOpen] = useState(false);
  const [pickupDraftTime, setPickupDraftTime] = useState<Dayjs | null>(null);
  const [pickupPickerView, setPickupPickerView] = useState("day");
  const [pickupTimeError, setPickupTimeError] = useState("");
  const [availableTimes, setAvailableTimes] = useState<string[]>([]);
  const [deliveryAddressFlatNo, setDeliveryAddressFlatNo] = useState("");
  const [deliveryAddressLandmark, setDeliveryAddressLandmark] = useState("");
  const [selectedType, setSelectedType] = useState("delivery");
  const [isVisible, setIsVisible] = useState(false);
  const [openAlternatePickup, setOpenAlternatePickup] = useState(!isMobileScreen);
  const [openAlternateDelivery, setOpenAlternateDelivery] = useState(!isMobileScreen);
  const [openDeliveryInstructions, setOpenDeliveryInstructions] = useState(!isMobileScreen);
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [additionalInfoName, setAdditionalInfoName] = useState("");
  const [additionalInfoPhoneNo, setAdditionalInfoPhoneNo] = useState("");
  const [avoidRingingBell, setAvoidRingingBell] = useState(false);
  const [leaveAtDoor, setLeaveAtDoor] = useState(false);
  const [errors, setErrors] = useState<{ name?: string; contact?: string; phoneNo?: string; additionalInfoPhoneNo?: string }>({});
  const [isEditable, setIsEditable] = useState(false);
  const skipAdditionalInfoPersistence = useRef(false);
  const someoneElseOrderRef = useRef({ name: "", contact: "", phoneNo: "" });
 
  // opt_in is stored in checkout slice so payment can read it
  const optIn = useAppSelector((state) => state.CheckoutState.opt_in);
  // dispatch actions to update opt_in in store
  const setOptInInStore = (value: boolean) => {
    dispatch(setOptIn(value));
  };
  const selectedAddressId = useAppSelector(
    (state) => state.CheckoutState.selectedAddressId
  );
  const { profileData }: any = useAppSelector((state) => state.ProfileState);

  const { addressList }: any = useAppSelector((state) => state?.AddressState);
  const { addTocart } = useAppSelector((state) => state.CartState);
  const itemTotal = Number(addTocart?.billingData?.total_without_delivery || 0);
  const isHomeDeliveryEligible = itemTotal >= 300;
  const savedSomeoneElseName = addTocart?.some_one_else_order?.name || "";
  const savedSomeoneElseContact = addTocart?.some_one_else_order?.phone_number || "";
  const savedSomeoneElsePhoneNo = addTocart?.some_one_else_order?.phone_no || "";
useEffect(() => {
  dispatch(setOptIn(true));
}, [dispatch]);

  useEffect(() => {
    dispatch(getAddressListAsync());
  }, []);
  useEffect(() => {
    if (!reduxDeliveryType) {
      dispatch(selectedDeliveryType("delivery"));
    }
    dispatch(getWhatsapCheckAsync());
  }, [dispatch, reduxDeliveryType]);

  useEffect(() => {
    if (!isHomeDeliveryEligible && reduxDeliveryType === "delivery") {
      setSelectedType("pickup");
      dispatch(selectedDeliveryType("pickup"));
    }
  }, [dispatch, isHomeDeliveryEligible, reduxDeliveryType]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const aId = localStorage.getItem("aId");
    const accessToken = getDecryptedToken();
    const anonymous_id = accessToken ? null : aId ? aId : null;
    dispatch(fetchCartListAsync(anonymous_id));
  }, []);
  useEffect(() => {
    const savedSomeoneElseOrder = addTocart?.some_one_else_order;
    const hasSavedSomeoneElseOrder =
      savedSomeoneElseOrder?.name || savedSomeoneElseOrder?.phone_number;
    const hasCurrentSomeoneElseEdits =
      someoneElseOrderRef.current.name || someoneElseOrderRef.current.contact;
    const cartMatchesCurrentEdits =
      savedSomeoneElseOrder?.name === someoneElseOrderRef.current.name &&
      savedSomeoneElseOrder?.phone_number === someoneElseOrderRef.current.contact;

    if (hasSavedSomeoneElseOrder && (!hasCurrentSomeoneElseEdits || !cartMatchesCurrentEdits)) {
      setName(addTocart?.some_one_else_order?.name || "");
      setContact(addTocart?.some_one_else_order?.phone_number || "");
      setPhoneNo(addTocart?.some_one_else_order?.phone_no || "");
      setIsVisible(true);
      setIsEditable(false);
    } else if (!hasSavedSomeoneElseOrder && !hasCurrentSomeoneElseEdits) {
      setName("");
      setContact("");
      setPhoneNo("");
      setIsVisible(false);
      setIsEditable(true);
    }

    if (addTocart?.additional_info || addTocart?.phone_no) {
      setAdditionalInfoName(addTocart?.additional_info || "");
      setAdditionalInfoPhoneNo(addTocart?.phone_no || "");
      skipAdditionalInfoPersistence.current = true;
      if (isMobileScreen) setOpenAlternateDelivery(true);
    }

    if (hasSavedSomeoneElseOrder) {
      if (isMobileScreen) setIsVisible(true);
    }

    if (reduxDeliveryInstructions) {
      const avoid = !!reduxDeliveryInstructions.avoidRingingBell;
      const leave = !!reduxDeliveryInstructions.leaveAtDoor;
      setAvoidRingingBell(avoid);
      setLeaveAtDoor(leave);
      if (isMobileScreen && (avoid || leave)) {
        setOpenDeliveryInstructions(true);
      }
    }
  }, [addTocart, reduxDeliveryInstructions, isMobileScreen]);

  useEffect(() => {
    if (skipAdditionalInfoPersistence.current) {
      skipAdditionalInfoPersistence.current = false;
      return;
    }
    dispatch(
      setAdditionalInfo({
        additional_info: additionalInfoName,
        phone_no: additionalInfoPhoneNo,
      })
    );
  }, [additionalInfoName, additionalInfoPhoneNo, dispatch]);

  useEffect(() => {
    if (
      !name.trim() &&
      !contact.trim() &&
      (savedSomeoneElseName || savedSomeoneElseContact)
    ) {
      someoneElseOrderRef.current = {
        name: savedSomeoneElseName,
        contact: savedSomeoneElseContact,
        phoneNo: savedSomeoneElsePhoneNo,
      };
      return;
    }

    someoneElseOrderRef.current = { name, contact, phoneNo };
    dispatch(
      setSomeOneElseOrder({
        name,
        phone_number: contact,
        phone_no: phoneNo,
      })
    );

    if (!name.trim() || !contact.trim()) return;

    const saveTimer = window.setTimeout(() => {
      dispatch(
        orderForSomeOneElseAsync({
          name: name.trim(),
          phone_number: contact.trim(),
        })
      );
    }, 300);

    return () => window.clearTimeout(saveTimer);
  }, [name, contact, phoneNo, savedSomeoneElseName, savedSomeoneElseContact, savedSomeoneElsePhoneNo, dispatch]);

  useEffect(() => {
    return () => {
      const { name: latestName, contact: latestContact } = someoneElseOrderRef.current;
      if (latestName.trim() && latestContact.trim()) {
        dispatch(
          orderForSomeOneElseAsync({
            name: latestName.trim(),
            phone_number: latestContact.trim(),
          })
        );
      }
    };
  }, [dispatch]);

  useEffect(() => {
    if (
      isMobileScreen &&
      selectedType === "pickup" &&
      (additionalInfoName.trim() || additionalInfoPhoneNo.trim())
    ) {
      setOpenAlternatePickup(true);
    }
  }, [selectedType, additionalInfoName, additionalInfoPhoneNo, isMobileScreen]);

  useEffect(() => {
    if (addressList?.data?.length > 0 && selectedAddressId) {
      const addr = addressList.data.filter(
        (item: any) => item.id === selectedAddressId
      )[0];

      if (addr) {
        setDeliveryAddressFlatNo(addr.flat_no || "");
        setDeliveryAddressLandmark(addr.landmark || "");
      }
    }
  }, [selectedAddressId, addressList]);
const selectedAddress = addressList?.data?.find(
  (item: any) => item.id === selectedAddressId
);
 const hasAddress = !!selectedAddress;
console.log("Delivery Address", selectedAddress);
useEffect(() => {
  if (!reduxSlotValue || !deliveryInfoOptions?.data?.length) return;

  const savedSlot: DeliverySlotSelection = typeof reduxSlotValue === "object"
    ? reduxSlotValue
    : { id: String(reduxSlotValue), value: "" };

  const matchedOption = deliverySlots.find(
    (option: any) =>
      String(option.slot_id) === String(savedSlot.id) &&
      (!savedSlot.date || String(option.date) === String(savedSlot.date)) &&
      (!savedSlot.start_time || String(option.start_time) === String(savedSlot.start_time))
  );

  if (matchedOption) {
    setSlotValue({
      id: String(matchedOption.slot_id),
      date: matchedOption.date,
      start_time: matchedOption.start_time,
      delivery_slot: matchedOption.delivery_slot,
      value:
        deliveryInfoOptions.pickup === "Not Available"
          ? String(matchedOption.date ?? "")
          : String(matchedOption.delivery_slot ?? ""),
    });
  }
}, [reduxSlotValue, deliveryInfoOptions]);
  useEffect(() => {
    if (reduxDeliveryType) {
      setSelectedType(reduxDeliveryType);
    }
  }, [reduxDeliveryType]);

  useEffect(() => {
    if (reduxDeliveryDate) {
      setSelectedDate(reduxDeliveryDate);
    }
  }, [reduxDeliveryDate]);

 useEffect(() => {
  if (reduxDeliveryDate && reduxPickupTime) {
    const parsed = dayjs(
      `${reduxDeliveryDate}T${reduxPickupTime}`
    );

    if (parsed.isValid()) {
      setSelectedTime(parsed);
      setSelectedDate(
        parsed.format("YYYY-MM-DD")
      );
    }
  }
}, [
  reduxDeliveryDate,
  reduxPickupTime,
]);

  useEffect(() => {
    if (reduxFlatNo !== undefined && reduxFlatNo !== null) {
      setDeliveryAddressFlatNo(reduxFlatNo);
    }
  }, [reduxFlatNo]);

  useEffect(() => {
    if (reduxLandmark !== undefined && reduxLandmark !== null) {
      setDeliveryAddressLandmark(reduxLandmark);
    }
  }, [reduxLandmark]);

  // Persist the complete selection because slot IDs repeat on different dates.
  useEffect(() => {
    if (!slotValue.id) return;

    const selectedOption = deliverySlots.find(
      (option: any) => String(option.slot_id) === slotValue.id
        && (!slotValue.date || String(option.date ?? "") === String(slotValue.date))
        && (!slotValue.start_time || String(option.start_time ?? "") === String(slotValue.start_time))
    );

    if (selectedOption) {
      const selection: DeliverySlotSelection = {
        id: slotValue.id,
        date: selectedOption.date,
        start_time: selectedOption.start_time,
        delivery_slot: selectedOption.delivery_slot,
        value: slotValue.value,
      };
      if (JSON.stringify(selection) !== JSON.stringify(reduxSlotValue)) {
        dispatch(selectedDeliverySlot(selection));
      }
    }
  }, [slotValue, deliveryInfoOptions, deliverySlots, reduxSlotValue, dispatch]);
  useEffect(() => {
    dispatch(setDeliveryAddressFlatNoInStore(deliveryAddressFlatNo));
  }, [deliveryAddressFlatNo, dispatch]);

  useEffect(() => {
    dispatch(setDeliveryAddressLandmarkInStore(deliveryAddressLandmark));
  }, [deliveryAddressLandmark, dispatch]);

  const getDefaultPickupTimeForDate = (date: Dayjs) => {
    const today = dayjs();
    const isToday = date.isSame(today, "day");

    if (isToday) {
      const currentHour = today.hour();
      const currentMinute = today.minute();
      const bufferHour = Math.ceil((currentHour + 3 + (currentMinute > 0 ? 1 : 0)) / 1);
      const minHour = Math.max(bufferHour, 10);
      return date.set("hour", Math.min(minHour, 21)).set("minute", 0).set("second", 0);
    }

    return date.set("hour", 10).set("minute", 0).set("second", 0);
  };

  const buildDeliveryAddressSummary = () => {
    const baseAddress = [
      deliveryAddressFlatNo,
      deliveryAddressLandmark,
      selectedAddress?.area,
      selectedAddress?.address_3,
      selectedAddress?.street,
      selectedAddress?.address_1,
      selectedAddress?.address_2,
    ].filter((part) => part && String(part).trim() !== "");

    const deduped = Array.from(new Set(baseAddress.map((part) => String(part).trim())));
    return deduped.join(", ");
  };

  const formattedPickupDateTime = selectedTime
    ? selectedTime.format("DD MMM, YYYY h:mm A")
    : "";

  const onNextClick = (active: any) => {
    const errors: Record<string, string> = {};
    let hasError = false;

    const nameFilled = name.trim() !== "";
    const contactFilled = contact.trim() !== "";
    const phoneNoFilled = phoneNo.trim() !== "";

    if ((nameFilled && !contactFilled) || (!nameFilled && contactFilled)) {
      if (!nameFilled) errors["name"] = "Name is required.";
      if (!contactFilled) errors["contact"] = "Contact number is required.";
      hasError = true;
    }
    if (nameFilled && contactFilled) {
      const mobileNumberRegex = /^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/;
      if (!mobileNumberRegex.test(contact)) {
        errors["contact"] = "Please enter a valid contact number.";
        hasError = true;
      }
    }

    // Validate phone_no only if filled (optional field)
    if (phoneNoFilled) {
      const mobileNumberRegex = /^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/;
      if (!mobileNumberRegex.test(phoneNo)) {
        errors["phoneNo"] = "Please enter a valid phone number.";
        hasError = true;
      }
    }

    const additionalInfoPhoneNoFilled = additionalInfoPhoneNo.trim() !== "";
    if (additionalInfoPhoneNoFilled) {
      const tenDigitMobileRegex = /^[6-9]\d{9}$/;
      if (!tenDigitMobileRegex.test(additionalInfoPhoneNo.trim())) {
        errors["additionalInfoPhoneNo"] = "Please enter a valid 10-digit mobile number.";
        hasError = true;
      }
    }

    if (hasError) {
      setErrors(errors);
      return;
    }
    if (nameFilled && contactFilled) {
      const payload = {
        name,
        phone_number: contact,
      };
      dispatch(orderForSomeOneElseAsync(payload));
    }

    // Store additional information in Redux
    if (additionalInfoName || additionalInfoPhoneNo) {
      dispatch(setAdditionalInfo({
        additional_info: additionalInfoName,
        phone_no: additionalInfoPhoneNo,
      }));
    }

    // 5. Always go to the next step if no errors
    dispatch(setStepperActiveMenu(active));
  };

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const toggleAlternatePickup = () => setOpenAlternatePickup(!openAlternatePickup);
  const toggleAlternateDelivery = () => setOpenAlternateDelivery(!openAlternateDelivery);
  const toggleDeliveryInstructions = () => setOpenDeliveryInstructions(!openDeliveryInstructions);

  const handleAvoidRingingBellChange = (checked: boolean) => {
    setAvoidRingingBell(checked);
    dispatch(
      selectedDeliveryInstructions({
        avoidRingingBell: checked,
        leaveAtDoor,
      })
    );
  };

  const handleLeaveAtDoorChange = (checked: boolean) => {
    setLeaveAtDoor(checked);
    dispatch(
      selectedDeliveryInstructions({
        avoidRingingBell,
        leaveAtDoor: checked,
      })
    );
  };

  // useEffect(() => {
  //   if (name.trim() && contact.trim()) {
  //     dispatch(
  //       setSomeOneElseOrder({
  //         name: name.trim(),
  //         phone_number: contact.trim(),
  //         // phone_no: phoneNo.trim(),
  //       })
  //     );
  //   }
  // }, [name, contact, phoneNo, dispatch]);

  const isInputFilled =
    (slotValue?.value?.trim() !== "" && (deliveryAddressFlatNo.trim() !== "" || deliveryAddressLandmark.trim() !== "")) ||
    selectedType === "pickup";
  const inputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // const { name, value } = event.target;
    const value = event.target.value;
    setDeliveryAddressFlatNo(value);
    // setDeliveryAddress(event.target);
    // let curErrors: any = { ...errors };
    // delete curErrors[name];
    // setErrors(curErrors);
    // setLoginData({
    //   ...loginData,
    //   [name]: value,
    // });
  };
  useEffect(() => {
    dispatch(setPayButtonDisabled(!isInputFilled));
  }, [isInputFilled, dispatch]);
  useEffect(() => {
    dispatch(getDeliveryInfoListAsync());
  }, []);

  // Sync selectedTime to Redux whenever it changes
  useEffect(() => {
    if (selectedTime) {
      dispatch(selectedPickupTime(selectedTime.format("HH:mm")));
    }
  }, [selectedTime, dispatch]);
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSelectedType(value);
    dispatch(selectedDeliveryType(value));
  };
  const handleDateChange = (newDate: Dayjs | null) => {
    const formattedDate = newDate ? newDate.format("YYYY-MM-DD") : null;
    setSelectedDate(formattedDate);
    dispatch(selectedDeliveryDate(formattedDate));
    
    // Generate available times based on selected date
    generateAvailableTimes(newDate);

    // Set default time based on selected date
    if (newDate) {
      const today = dayjs().format("YYYY-MM-DD");
      const isToday = newDate.format("YYYY-MM-DD") === today;

      let defaultTime: Dayjs;

      if (isToday) {
        // Same-day: Current time + 3 hours (rounded up to nearest hour)
        const currentHour = dayjs().hour();
        const currentMinute = dayjs().minute();
        const bufferHour = Math.ceil((currentHour + 3 + (currentMinute > 0 ? 1 : 0)) / 1);
        
        if (bufferHour <= 21) {
          defaultTime = dayjs().set("hour", bufferHour).set("minute", 0).set("second", 0);
        } else {
          // If buffer exceeds 9 PM, no default time
          setSelectedTime(null);
          dispatch(selectedPickupTime(""));
          return;
        }
      } else {
        // Future date: 10:00 AM
        defaultTime = dayjs(newDate).set("hour", 10).set("minute", 0).set("second", 0);
      }

      setSelectedTime(defaultTime);
      dispatch(selectedPickupTime(defaultTime.format("HH:mm")));
    } else {
      // Reset time if no date selected
      setSelectedTime(null);
      dispatch(selectedPickupTime(""));
    }
  };

  const generateAvailableTimes = (selectedDateObj: Dayjs | null) => {
    if (!selectedDateObj) {
      setAvailableTimes([]);
      return;
    }

    const times: string[] = [];
    const today = dayjs().format("YYYY-MM-DD");
    const selectedDate = selectedDateObj.format("YYYY-MM-DD");
    const isToday = selectedDate === today;

    let startHour = 10; // 10 AM
    const endHour = 20; // 8 PM (all days restricted)

    // If same day, apply 3-hour buffer
    if (isToday) {
      const currentHour = dayjs().hour();
      const currentMinute = dayjs().minute();
      startHour = Math.ceil((currentHour + 3 + (currentMinute > 0 ? 1 : 0)) / 1);
      if (startHour < 10) startHour = 10;
      if (startHour > 21) {
        setAvailableTimes([]);
        return;
      }
    }

    for (let hour = startHour; hour <= endHour; hour++) {
      times.push(`${hour.toString().padStart(2, "0")}:00`);
    }

    setAvailableTimes(times);
  };

  const handleTimeChange = (newTime: Dayjs | null) => {
    if (newTime) {
      const timeString = newTime.format("HH:mm");
      setSelectedTime(newTime);
      dispatch(selectedPickupTime(timeString));
    }
  };

  const handleRedirectToMap = (latitude: any, longitude: any) => {
    const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
    // window.location.href = googleMapsUrl; // This will open the Google Maps URL
    window.open(googleMapsUrl, "_blank");
  };

  // Check if same day delivery is available for all products
  const isSameDayDeliveryAvailable = () => {
    if (!addTocart?.data || addTocart.data.length === 0) {
      return true; // Default to available if no cart data
    }
    // If any product has same_day_delivery: false, return false
    return !addTocart.data.some((product: any) => product.same_day_delivery === false);
  };

 // -----------------------------
// Pickup Date/Time Helpers
// -----------------------------

const getMinPickupDateTime = () => {
  // Same-day delivery is not available
  if (!isSameDayDeliveryAvailable()) {
    return dayjs()
      .add(1, "day")
      .set("hour", 10)
      .set("minute", 0)
      .set("second", 0)
      .set("millisecond", 0);
  }

  const now = dayjs();

  // Minimum = current time + 3 hours, but never earlier than 10:00 AM.
  let minTime = now
    .add(3, "hour")
    .set("second", 0)
    .set("millisecond", 0);

  // Pickup cannot be before 10 AM
  const today10AM = now
    .startOf("day")
    .set("hour", 10)
    .set("minute", 0)
    .set("second", 0)
    .set("millisecond", 0);

  if (minTime.isBefore(today10AM)) {
    minTime = today10AM;
  }

  return minTime;
};

const getMaxPickupDateTime = () => {
  return dayjs()
    .add(2, "day")
    .set("hour", 21)
    .set("minute", 0)
    .set("second", 0)
    .set("millisecond", 0);
};


// -----------------------------
// Validate selected pickup time
// -----------------------------

const validateAndCorrectTime = (time: Dayjs) => {
  if (!time || !time.isValid()) {
    return time;
  }

  const now = dayjs();

  let correctedTime = time
    .set("second", 0)
    .set("millisecond", 0);

  const isToday = correctedTime.isSame(now, "day");

  // --------------------------------
  // Today's pickup
  // --------------------------------
  if (isToday) {
    const minPickupTime = getMinPickupDateTime();

    // If selected time is before minimum time,
    // move it to the minimum allowed time.
    if (correctedTime.isBefore(minPickupTime)) {
      correctedTime = minPickupTime;
    }
  } else {
    // --------------------------------
    // Future date pickup
    // --------------------------------
    const minFutureTime = correctedTime
      .startOf("day")
      .set("hour", 10)
      .set("minute", 0)
      .set("second", 0)
      .set("millisecond", 0);

    if (correctedTime.isBefore(minFutureTime)) {
      correctedTime = minFutureTime;
    }
  }

  // --------------------------------
  // Maximum pickup time = 9 PM
  // --------------------------------
  const maxTime = correctedTime
    .startOf("day")
    .set("hour", 21)
    .set("minute", 0)
    .set("second", 0)
    .set("millisecond", 0);

  if (correctedTime.isAfter(maxTime)) {
    correctedTime = maxTime;
  }

  return correctedTime;
};

const isValidPickupTime = (time: Dayjs) => {
  if (!time || !time.isValid()) return false;

  const hour = time.hour();
  const isWithinBusinessHours =
    hour >= 10 && (hour < 21 || (hour === 21 && time.minute() === 0));
  const isBeforeTodayMinimum =
    time.isSame(dayjs(), "day") && time.isBefore(getMinPickupDateTime());

  return isWithinBusinessHours && !isBeforeTodayMinimum;
};


// -----------------------------
// Disable pickup dates
// -----------------------------

const shouldDisablePickupDate = (date: Dayjs) => {
  const today = dayjs();
  const todayLastPickupTime = today
    .startOf("day")
    .set("hour", 21)
    .set("minute", 0)
    .set("second", 0)
    .set("millisecond", 0);

  // If same-day delivery is not available,
  // today should not be selectable.
  if (
    date.isSame(today, "day") &&
    (!isSameDayDeliveryAvailable() || getMinPickupDateTime().isAfter(todayLastPickupTime))
  ) {
    return true;
  }

  return false;
};


// -----------------------------
// Disable pickup hours
// -----------------------------

const shouldDisableHours = (timeValue: any) => {
  const pickerDate =
    typeof timeValue === "number"
      ? selectedTime || dayjs()
      : dayjs(timeValue || selectedTime || dayjs());

  const hour =
    typeof timeValue === "number"
      ? timeValue
      : timeValue?.hour?.() ?? pickerDate.hour();

  const minute =
    typeof timeValue === "number"
      ? 0
      : timeValue?.minute?.() ?? pickerDate.minute();

  const now = dayjs();

  const isToday = pickerDate.isSame(now, "day");

  // --------------------------------
  // Today
  // --------------------------------
  if (isToday) {
    const minPickupTime = getMinPickupDateTime();

    const minHour = minPickupTime.hour();

    if (hour < minHour) {
      return true;
    }

    // If it is the minimum hour, make sure
    // the selected minute is not before minimum.
    if (
      hour === minHour &&
      minute < minPickupTime.minute()
    ) {
      return true;
    }
  }

  // --------------------------------
  // Future dates
  // --------------------------------
  if (!isToday && hour < 10) {
    return true;
  }

  // --------------------------------
  // Pickup allowed only until 9 PM
  // --------------------------------
  if (hour > 21) {
    return true;
  }

  if (hour === 21 && minute > 0) {
    return true;
  }

  return false;
};

  // Disable today's date if same_day_delivery is false
 
  // Initialize pickup time based on same_day_delivery availability
  useEffect(() => {
    if (selectedType === "pickup" && !selectedTime) {
      if (!isSameDayDeliveryAvailable()) {
        // Set to tomorrow at 10:00 AM if same_day_delivery is false
        const tomorrowAt10 = dayjs().add(1, "day").set("hour", 10).set("minute", 0).set("second", 0);
        setSelectedTime(tomorrowAt10);
        dispatch(selectedDeliveryDate(tomorrowAt10.format("YYYY-MM-DD")));
        dispatch(selectedPickupTime("10:00"));
      } else {
        const minimumPickupTime = getMinPickupDateTime();
        const lastPickupTimeToday = dayjs()
          .startOf("day")
          .set("hour", 21)
          .set("minute", 0)
          .set("second", 0);

        // Use the first valid time today; if today's window has closed,
        // start tomorrow at 10:00 AM.
        if (minimumPickupTime.isSame(dayjs(), "day") && !minimumPickupTime.isAfter(lastPickupTimeToday)) {
          const defaultTime = minimumPickupTime;
          setSelectedTime(defaultTime);
          dispatch(selectedDeliveryDate(defaultTime.format("YYYY-MM-DD")));
          dispatch(selectedPickupTime(defaultTime.format("HH:mm")));
        } else {
          const tomorrowAt10 = dayjs()
            .add(1, "day")
            .set("hour", 10)
            .set("minute", 0)
            .set("second", 0);
          setSelectedTime(tomorrowAt10);
          dispatch(selectedDeliveryDate(tomorrowAt10.format("YYYY-MM-DD")));
          dispatch(selectedPickupTime("10:00"));
        }
      }
    }
  }, [selectedType, addTocart?.data]);
const [openAddressPopup, setOpenAddressPopup] = useState(false);

const handleChangeAddress = () => {
  setOpenAddressPopup(true);
};

const handleCloseAddressPopup = () => {
  setOpenAddressPopup(false);
};
  const handleDelete = () => {
    dispatch(removeSomeOneElseAsync()).then((response: any) => {
      if (response?.meta?.requestStatus === "fulfilled") {
        someoneElseOrderRef.current = { name: "", contact: "", phoneNo: "" };
        setName("");
        setContact("");
        setPhoneNo("");
        setIsVisible(false);
        setIsEditable(true);
        return;
      }

      dispatch(
        showSnackbar({
          message: "Please try again later.",
          severity: "error",
          autoHide: 3000,
        })
      );
    });
  };
  return (
    <div
      style={{
        fontFamily: "Albert Sans, sans-serif",
        fontSize: "14px",
        lineHeight: "22px",
        fontWeight: "400",
        maxWidth: 650,
        margin: "0 auto",
        }}
    >
      <style>{`
        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      `}</style>
     
      {isMobileScreen && (
        <>
            <div
  style={{
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
  }}
>
  <ArrowBackIcon
    onClick={() => dispatch(setStepperActiveMenu("address"))}
    style={{
      cursor: "pointer",
      marginLeft: "-36px", // Adjust as needed (-16px, -24px, etc.)
      marginRight: "8px",
      fontSize: "28px",
    }}
  />

  <h2
    style={{
      margin: 0,
      fontSize: "18px",
      fontWeight: 600,
    }}
  >
    Delivery Address
  </h2>
</div>
    {hasAddress ? (
  <SelectedAddressMobile
    address={selectedAddress}
    onChange={handleChangeAddress}
  />
) : (
  <div
    style={{
      background: "#fff",
      border: "1px solid #E5E5E5",
      borderRadius: "8px",
      padding: "20px",
      textAlign: "center",
      marginBottom: "16px",
    }}
  >
    <p
      style={{
        marginBottom: "16px",
        color: "#666",
        fontSize: "15px",
      }}
    >
      Please add your delivery address before proceeding to delivery options.
    </p>

    <CustomButton
      name="Add Delivery Address"
      onClick={handleChangeAddress}
    />
  </div>
)}
    </>
  )}

      <h2>Delivery Info</h2> 
      <div className="mt-4 w-70">
        {deliveryInfoOptions?.pickup && (
          <FormControl required>
            {/* Optional: FormLabel>
          {/* <FormLabel id="demo-row-radio-buttons-group-label">Type</FormLabel> */}
            <RadioGroup
              onChange={handleRadioChange}
              row
              value={selectedType}
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="pickup"
                control={<Radio />}
                label="Shop Pickup"
              />
              <Tooltip
                placement={isMobileScreen ?"top":"right"}
                title={
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      lineHeight: 1.5,
                    }}
                  >
                    <InfoOutlinedIcon sx={{ fontSize: "22px", flexShrink: 0 }} />
                   <span style={{ whiteSpace: isMobileScreen ? "normal" : "nowrap" }}>
                     Add items worth <strong>₹300</strong> or more to get{" "}
                     <strong>Home Delivery</strong>.
                    </span>
                  </span>
                }
                arrow
                enterDelay={0}
                leaveDelay={0}
                disableHoverListener={isHomeDeliveryEligible}
                disableTouchListener={isHomeDeliveryEligible}
                enterTouchDelay={0}
                leaveTouchDelay={4000}
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#e3f5fc",
                      color: "#d32f2f",
                      fontFamily: "inherit",
                      fontSize: "14px",
                      fontWeight: 500,
                      maxWidth: isMobileScreen ? "min(390px, calc(100vw - 32px))" : "none",
                      whiteSpace: isMobileScreen ? "normal" : "nowrap",
                      padding: "14px 16px",
                      borderRadius: "3px",
                    },
                  },
                  arrow: {
                    sx: { color: "#e3f5fc" },
                  },
                }}
              >
                <span style={{ display: "inline-block" }}>
                  <FormControlLabel
                    value="delivery"
                    control={<Radio disabled={!isHomeDeliveryEligible} />}
                    label="Home Delivery"
                    disabled={!isHomeDeliveryEligible}
                  />
                </span>
              </Tooltip>
            </RadioGroup>
          </FormControl>
        )}

        {selectedType === "pickup" && (
          <div id="Deliverybakery3" className="desc mt-3">
             {/* Same Day Delivery Message */}
            {addTocart?.data?.some((item: any) => !item.same_day_delivery) && deliveryInfoOptions?.same_day_message && (
               <Alert severity="info" sx={{ color: "#d32f2f", fontFamily: "inherit", fontSize: "14px", marginBottom: "16px", fontWeight: "500", "& .MuiAlert-icon": { color: "#d32f2f" } }}> {deliveryInfoOptions.same_day_message}</Alert>
            
            )}
            <p className="mb-3 orange-txt">
              Please contact the pickup point before arrival
            </p>
            <div>
              <div className="tf-field style-1 mb_15">
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    minDate={dayjs()}
                    maxDate={dayjs().add(2, "day")}
                    format="DD-MM-YYYY"
                    value={selectedDate ? dayjs(selectedDate) : null}
                    onChange={(newDate) => handleDateChange(newDate)}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        placeholder: "Select your pickup date",
                        inputProps: {
                          placeholder: "Select your pickup date",
                          readOnly: true,
                        },
                      },
                    }}
                  />
                </LocalizationProvider> */}
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    label="Select Pickup Date & Time"
                    value={selectedTime}
                    onChange={(newValue) => {
                      if (newValue) {
                        // Validate and correct the time
                        const correctedTime = validateAndCorrectTime(newValue);
                        setSelectedTime(correctedTime);

                        const formattedDate = correctedTime.format("YYYY-MM-DD");
                        setSelectedDate(formattedDate);

                        dispatch(selectedDeliveryDate(formattedDate));
                        dispatch(selectedPickupTime(correctedTime.format("HH:mm")));
                      }
                    }}
                    minDateTime={getMinPickupDateTime()}
                    maxDateTime={getMaxPickupDateTime()}
                    shouldDisableDate={shouldDisablePickupDate}
                    shouldDisableTime={shouldDisableHours}
                    viewRenderers={{
                      hours: renderTimeViewClock,
                      minutes: renderTimeViewClock,
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        error: false,
                        inputProps: {
                          readOnly: true,
                        },
                      },
                    }}
                  />
                </LocalizationProvider> */}
<div>
 
 <LocalizationProvider dateAdapter={AdapterDayjs}>
  <MobileDateTimePicker
    open={pickupDateTimePickerOpen}
    onOpen={() => {
      setPickupDraftTime(selectedTime ? dayjs(selectedTime) : null);
      setPickupPickerView("day");
      setPickupTimeError("");
      setPickupDateTimePickerOpen(true);
    }}
    onClose={() => setPickupDateTimePickerOpen(false)}
    label="Select Pickup Date & Time"
    format="MM/DD/YYYY hh:mm A"

    value={pickupDraftTime || selectedTime}

    // IMPORTANT:
    // Do not validate/correct the value here.
    // MobileDateTimePicker fires onChange while the user
    // is still selecting day -> hour -> minute.
    onChange={(newValue) => {
      if (!newValue || !newValue.isValid()) {
        return;
      }

      const incomingTime = dayjs(newValue);
      const currentDraft = pickupDraftTime || selectedTime || incomingTime;
      const nextDraft =
        pickupPickerView === "day"
          ? incomingTime
          : currentDraft
            .set("hour", incomingTime.hour())
            .set("minute", incomingTime.minute())
            .set("second", incomingTime.second())
            .set("millisecond", incomingTime.millisecond());

      setPickupDraftTime(nextDraft);
      setPickupTimeError("");
    }}

    onViewChange={(view) => setPickupPickerView(view)}

    // Validate only after the user finishes selecting.
    onAccept={(newValue) => {
      if (!newValue || !newValue.isValid()) {
        return;
      }

      const incomingTime = dayjs(newValue);
      const draftTime = pickupDraftTime || selectedTime || incomingTime;
      const selectedDateTime = incomingTime
        .set("year", draftTime.year())
        .set("month", draftTime.month())
        .set("date", draftTime.date());

      const correctedTime =
        validateAndCorrectTime(selectedDateTime);

if (!isValidPickupTime(selectedDateTime)) {
        setPickupTimeError(
          "Please select a time between 10 AM-9 PM and atleast 3 hours from now."
        );
        return;
      }

      setSelectedTime(correctedTime);

      const formattedDate =
        correctedTime.format("YYYY-MM-DD");

      const formattedTime =
        correctedTime.format("HH:mm");

      setSelectedDate(formattedDate);

      dispatch(
        selectedDeliveryDate(formattedDate)
      );

      dispatch(
        selectedPickupTime(formattedTime)
      );

      setPickupDateTimePickerOpen(false);
    }}

    minDateTime={getMinPickupDateTime()}
    maxDateTime={getMaxPickupDateTime()}

    shouldDisableDate={shouldDisablePickupDate}

    shouldDisableTime={shouldDisableHours}

    ampm={true}

    closeOnSelect={false}

    views={["day", "hours", "minutes"]}

    viewRenderers={{
      hours: renderTimeViewClock,
      minutes: renderTimeViewClock,
    }}

    slotProps={{
      textField: {
        fullWidth: true,
        error: Boolean(pickupTimeError),
        helperText: pickupTimeError,
        onClick: () => {
          setPickupDateTimePickerOpen(true);
        },
      },
    }}
  />
</LocalizationProvider>
</div>
              </div>
            </div>
            <div>
              <div className="tf-field style-1 mb_15">
              
  
              </div>
            </div>
            <div>
              <fieldset className="box fieldset">
                <span>Phone No.</span>
                <div>
                  <TextField 
                    type="text"   
                    value={profileData?.data?.phone_number}
                    fullWidth
                    size="small"
                    // variant="outlined"
                    inputProps={{
                      readOnly: true,
                    }}
                  />
                </div>
              </fieldset>
            </div>

            <p className="orange-txt" style={{ paddingTop: "1rem" }}>
              <b>Contact Details</b>
            </p>

            <p>
              {deliveryInfoOptions?.shopDetails?.shop_name}
              <br />
              {deliveryInfoOptions?.shopDetails?.shop_location}
              {/* <br />
              Ernakulam, Kerala 682021 */}
              <br />
              Phone No.: {deliveryInfoOptions?.shopDetails?.shop_phone}
            </p>

            <p className="mt-3">
              <a
                href="javascript:void(0)"
                className="orange-txt"
                onClick={(e) => {
                  e.preventDefault();
                  handleRedirectToMap(
                    deliveryInfoOptions?.shopDetails?.latitude,
                    deliveryInfoOptions?.shopDetails?.longitude
                  );
                }}
              >
                <b>
                  <i className="fa fa-location-arrow"></i>
                  <span style={{ paddingLeft: "7px" }}>
                    Pickup point Location Map
                  </span>
                </b>
              </a>
            </p>

            {/* Alternate Contact Details for Shop Pickup (collapsible on mobile) */}
            {isMobileScreen ? (
              <div className="mb-3 mt-3">
                <p>
                  <span onClick={toggleAlternatePickup} style={{ cursor: "pointer" }}>
                    <i className={`fa fs-18 ${openAlternatePickup ? 'fa-minus-circle' : 'fa-plus-circle'} green-icon`} style={{ color: "green" }}></i>{" "}
                    <b>Alternate Contact Details</b>
                  </span>
                </p>
                {openAlternatePickup && (
                  <fieldset className="box fieldset mt-2">
                    <div className="row" style={{ marginTop: "3%", marginLeft: "0%" }}>
                      <div className="col-6 ps-0">
                        <fieldset className="box fieldset">
                          <span>Name</span>
                          <input
                            type="text"
                            placeholder="Enter name"
                            value={additionalInfoName}
                            onChange={(e) => setAdditionalInfoName(e.target.value)}
                            style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "4px" }}
                          />
                        </fieldset>
                      </div>
                      <div className="col-6 ps-0">
                        <fieldset className="box fieldset">
                          <span>Phone Number</span>
                          <input
                            type="text"
                            inputMode="numeric"
                            placeholder="Enter phone number"
                            value={additionalInfoPhoneNo}
                            onChange={(e) => setAdditionalInfoPhoneNo(e.target.value.replace(/\D/g, "").slice(0, 10))}
                            maxLength={10}
                            style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "4px", MozAppearance: "textfield", WebkitAppearance: "none" }}
                            onWheel={(e) => e.currentTarget.blur()}
                          />
                          {errors.additionalInfoPhoneNo ? (
                            <p style={{ color: "#d32f2f", margin: "8px 0 0", fontSize: "12px" }}>
                              {errors.additionalInfoPhoneNo}
                            </p>
                          ) : null}
                        </fieldset>
                      </div>
                    </div>
                  </fieldset>
                )}
              </div>
            ) : (
              <fieldset className="box fieldset mt-4">
                <label htmlFor="additionalInfo">Alternate Contact Details</label>
                <div className="row" style={{ marginTop: "3%", marginLeft: "0%" }}>
                  <div className="col-6 ps-0">
                    <fieldset className="box fieldset">
                      <span>Name</span>
                      <input
                        type="text"
                        placeholder="Enter name"
                        value={additionalInfoName}
                        onChange={(e) => setAdditionalInfoName(e.target.value)}
                        style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "4px" }}
                      />
                    </fieldset>
                  </div>
                  <div className="col-6 ps-0">
                    <fieldset className="box fieldset">
                      <span>Phone Number</span>
                      <input
                        type="text"
                        inputMode="numeric"
                        placeholder="Enter phone number"
                        value={additionalInfoPhoneNo}
                        onChange={(e) => setAdditionalInfoPhoneNo(e.target.value.replace(/\D/g, "").slice(0, 10))}
                        maxLength={10}
                        style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "4px", MozAppearance: "textfield", WebkitAppearance: "none" }}
                        onWheel={(e) => e.currentTarget.blur()}
                      />
                      {errors.additionalInfoPhoneNo ? (
                        <p style={{ color: "#d32f2f", margin: "8px 0 0", fontSize: "12px" }}>
                          {errors.additionalInfoPhoneNo}
                        </p>
                      ) : null}
                    </fieldset>
                  </div>
                </div>
              </fieldset>
            )}
          </div>
        )}
      </div>
      <div className=" w-70">
        {selectedType !== "pickup" && (
          <div className="desc">
            {/* Same Day Delivery Message */}
            {addTocart?.data?.some((item: any) => !item.same_day_delivery) && deliveryInfoOptions?.same_day_message && (
               <Alert severity="info" sx={{color: "#d32f2f", fontFamily: "inherit", fontSize: "14px", marginBottom: "16px", fontWeight: "500", "& .MuiAlert-icon": { color: "#d32f2f" } }}> {deliveryInfoOptions.same_day_message}</Alert>
            )}
            {/* Estimated Delivery Time */}
            <p className="mb-3 orange-txt">
              {/* Estimated Delivery time 30-120 mins */}
            </p>

            {/* Select Delivery Slot */}
            <fieldset className="box fieldset">
              <label htmlFor="country">Select a delivery Slot</label>
              <div>
                <Autocomplete
                  disablePortal
                  size="small"
                  options={deliverySlots.map((option: any) => ({
                    id: String(option?.slot_id ?? ""),
                    date: option?.date,
                    start_time: option?.start_time,
                    delivery_slot: option?.delivery_slot,
                    value:
                      deliveryInfoOptions?.pickup === "Not Available"
                        ? option?.date ?? ""
                        : option?.delivery_slot ?? "",
                  }))}
                  isOptionEqualToValue={(option, value) =>
                    String(option?.id) === String(value?.id)
                  }
                  // Render only the value of the option (either date or slot)
                  getOptionLabel={(option) => option?.value || ""} // Ensure we display the correct value (e.g., date or delivery slot)
                  renderInput={(params) => <TextField {...params} />}
                  id="slot"
                  value={
                    slotValue?.id
                      ? {
                          id: slotValue.id,
                          date: slotValue.date,
                          start_time: slotValue.start_time,
                          delivery_slot: slotValue.delivery_slot,
                          value: slotValue.value,
                        }
                      : null
                  }
                  onChange={(event, newValue) => {
                    if (newValue) {
                      const selectedOption = deliverySlots.find(
                        (option: any) => String(option.slot_id) === String(newValue.id)
                          && (!newValue.date || String(option.date ?? "") === String(newValue.date))
                          && (!newValue.start_time || String(option.start_time ?? "") === String(newValue.start_time))
                      );
                      setSlotValue({
                        id: String(newValue.id),
                        date: newValue.date,
                        start_time: newValue.start_time,
                        delivery_slot: newValue.delivery_slot,
                        value: String(newValue.value),
                      });
                      dispatch(selectedDeliveryDate(String(selectedOption?.date ?? newValue.value)));
                    } else {
                      setSlotValue({ id: "", value: "" });
                      dispatch(selectedDeliverySlot(""));
                      dispatch(selectedDeliveryDate(""));
                    }
                  }}
                />
              </div>
            </fieldset>

            {/* Delivery Address Input */}
            {deliveryAddressFlatNo && (
              <fieldset className="box fieldset mt-3">
                <label htmlFor="note" style={{ paddingBottom: "1rem" }}>
                 Your order will be delivered at the following address
                </label>{" "}
                <div
              style={{
              backgroundColor: "#f5f5f5",
              padding: "16px",
              borderRadius: "4px",
              marginBottom: "20px",
            }}
          >
            <p style={{ display: "flex", alignItems: "center", gap: "8px", margin: 0, marginBottom: "8px", fontWeight: 700, color: "#ef8d22", textTransform: "uppercase" }}>
              <LocationOnIcon sx={{ fontSize: "20px" }} />
              {selectedAddress?.address_type || "Address"}
            </p>
            <p style={{ margin: 0, fontWeight: 500, lineHeight: 1.5, wordBreak: "break-word" }}>
              {buildDeliveryAddressSummary() || `${deliveryAddressFlatNo}${deliveryAddressFlatNo && deliveryAddressLandmark ? ", " : ""}${deliveryAddressLandmark}`}
            </p>
          </div>
            </fieldset>)}
           {!hasAddress && isMobileScreen &&(<div className="box fieldset mt-3"/>)}
            {/* Additional Information Section (collapsible on mobile) */}
            {isMobileScreen ? (
              <div className="">
                <p>
                  <span onClick={toggleAlternateDelivery} style={{ cursor: "pointer" }}>
                    <i className={`fa fs-18 ${openAlternateDelivery ? 'fa-minus-circle' : 'fa-plus-circle'} green-icon`} style={{ color: "green" }}></i>{" "}
                    <b>Alternate Contact Details</b>
                  </span>
                </p>
                {openAlternateDelivery && (
                  <fieldset className="box fieldset mt-2">
                    <div className="row" style={{ marginTop: "3%", marginLeft: "0%" }}>
                      <div className="col-6 ps-0">
                        <fieldset className="box fieldset">
                          <span>Name</span>
                          <input
                            type="text"
                            placeholder="Enter name"
                            value={additionalInfoName}
                            onChange={(e) => setAdditionalInfoName(e.target.value)}
                            style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "4px" }}
                          />
                        </fieldset>
                      </div>
                      <div className="col-6 ps-0">
                        <fieldset className="box fieldset">
                          <span>Phone Number</span>
                          <input
                            type="text"
                            inputMode="numeric"
                            placeholder="Enter phone number"
                            value={additionalInfoPhoneNo}
                            onChange={(e) => setAdditionalInfoPhoneNo(e.target.value.replace(/\D/g, "").slice(0, 10))}
                            maxLength={10}
                            style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "4px", MozAppearance: "textfield", WebkitAppearance: "none" }}
                            onWheel={(e) => e.currentTarget.blur()}
                          />
                          {errors.additionalInfoPhoneNo ? (
                            <p style={{ color: "#d32f2f", margin: "8px 0 0", fontSize: "12px" }}>
                              {errors.additionalInfoPhoneNo}
                            </p>
                          ) : null}
                        </fieldset>
                      </div>
                    </div>
                  </fieldset>
                )}

                <p style={{ marginTop: "12px" }}>
                  <span onClick={toggleDeliveryInstructions} style={{ cursor: "pointer" }}>
                    <i className={`fa fs-18 ${openDeliveryInstructions ? 'fa-minus-circle' : 'fa-plus-circle'} green-icon`} style={{ color: "green" }}></i>{" "}
                    <b>Select Delivery Instructions</b>
                  </span>
                </p>
                {openDeliveryInstructions && (
                  <fieldset className="box fieldset mt-2" style={{ marginTop: "5%" }}>
                    <div>
                      <FormGroup>
                        <FormControlLabel
                          required
                          control={
                            <Checkbox
                              checked={avoidRingingBell}
                              onChange={(event) => handleAvoidRingingBellChange(event.target.checked)}
                            />
                          }
                          label="Avoid Ringing Bell"
                        />
                        <FormControlLabel
                          required
                          control={
                            <Checkbox
                              checked={leaveAtDoor}
                              onChange={(event) => handleLeaveAtDoorChange(event.target.checked)}
                            />
                          }
                          label="Leave at the Door"
                        />
                      </FormGroup>
                    </div>
                  </fieldset>
                )}
              </div>
            ) : (
              <>
                <fieldset className="box fieldset mt-4">
                  <label htmlFor="additionalInfo">Alternate Contact Details</label>
                  <div className="row" style={{ marginTop: "3%", marginLeft: "0%" }}>
                    <div className="col-6 ps-0">
                      <fieldset className="box fieldset">
                        <span>Name</span>
                        <input
                          type="text"
                          placeholder="Enter name"
                          value={additionalInfoName}
                          onChange={(e) => setAdditionalInfoName(e.target.value)}
                          style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "4px" }}
                        />
                      </fieldset>
                    </div>
                    <div className="col-6 ps-0">
                      <fieldset className="box fieldset">
                        <span>Phone Number</span>
                        <input
                          type="text"
                          inputMode="numeric"
                          placeholder="Enter phone number"
                          value={additionalInfoPhoneNo}
                          onChange={(e) => setAdditionalInfoPhoneNo(e.target.value.replace(/\D/g, "").slice(0, 10))}
                          maxLength={10}
                          style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "4px", MozAppearance: "textfield", WebkitAppearance: "none" }}
                          onWheel={(e) => e.currentTarget.blur()}
                        />
                        {errors.additionalInfoPhoneNo ? (
                          <p style={{ color: "#d32f2f", margin: "8px 0 0", fontSize: "12px" }}>
                            {errors.additionalInfoPhoneNo}
                          </p>
                        ) : null}
                      </fieldset>
                    </div>
                  </div>
                </fieldset>

                <fieldset className="box fieldset mt-4" style={{ marginTop: "5%" }}>
                  <label htmlFor="country">Select Delivery Instructions</label>
                  <div>
                    <FormGroup>
                      <FormControlLabel
                        required
                        control={
                          <Checkbox
                            checked={avoidRingingBell}
                            onChange={(event) => handleAvoidRingingBellChange(event.target.checked)}
                          />
                        }
                        label="Avoid Ringing Bell"
                      />
                      <FormControlLabel
                        required
                        control={
                          <Checkbox
                            checked={leaveAtDoor}
                            onChange={(event) => handleLeaveAtDoorChange(event.target.checked)}
                          />
                        }
                        label="Leave at the Door"
                      />
                    </FormGroup>
                  </div>
                </fieldset>
              </>
            )}

          </div>
        )}
            <div id="triggerDiv" style={{ marginTop: "12px"}}>
              <p>
                <span onClick={toggleVisibility}>
                  <i
                    className={`fa fs-18 ${isVisible ? 'fa-minus-circle' : 'fa-plus-circle'} green-icon`}
                    style={{ color: "green" }}
                  ></i>{" "}
                  {/* <span>
                    <AddIcon style={{ color: "green", fontSize: 30 }} />
                  </span> */}
                  <b>Order for someone else</b>
                </span>
              </p>
            </div>
            {isVisible && (
              <div id="targetDiv" style={{ display: "flex" , marginTop: "3%" }}>
                <div className="row" style={{ marginLeft: "1%" }}>
                  {/* Name Field */}
                  <div className="col-6 ps-0">
                    <fieldset className="box fieldset">
                      <span>Name</span>
                      <input
                        type="text"
                        placeholder="Enter name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        disabled={!isEditable}
                        style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "4px" }}
                      />
                    </fieldset>
                  </div>

                  {/* Contact No. Field */}
                  <div className="col-6 ps-0">
                    <fieldset className="box fieldset">
                      <span>Contact No.</span>
                      <input
                        type="number"
                        placeholder="Enter contact number"
                        value={contact}
                        onChange={(e) => setContact(e.target.value.slice(0, 10))}
                        disabled={!isEditable}
                        maxLength={10}
                        style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "4px", MozAppearance: "textfield", WebkitAppearance: "none" }}
                        onWheel={(e) => e.currentTarget.blur()}
                      />
                      {errors.contact ? (
                        <p style={{ color: "#d32f2f", margin: "8px 0 0", fontSize: "12px" }}>
                          {errors.contact}
                        </p>
                      ) : null}
                    </fieldset>
                  </div>
                  <div className="col-2 ps-0">
                    {addTocart?.some_one_else_order?.name ||
                    addTocart?.some_one_else_order?.phone_number ? (
                      <div
                        className="select-custom row"
                        style={{ marginTop: "25px" }}
                      >
                        {!isEditable ? (
                          <div
                            className="col-1"
                            style={{ marginRight: "1rem" }}
                          >
                            <button
                              onClick={() => setIsEditable(true)}
                              className="btn btn-warning me-2"
                            >
                              <i className="fa-solid fa-pen-to-square"></i>
                            </button>
                          </div>
                        ) : null}
                        <div className="col-1">
                          <button
                            onClick={handleDelete}
                            className="btn btn-danger"
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            )}
      </div>

      {/* <div className="box  mt-3">
        <FormControlLabel
          control={
            <Checkbox
              checked={optIn}
              onChange={(e) => setOptInInStore(e.target.checked)}
              color="primary"
            />
          }
          label="I agree to receive promotional messages and updates through whatsapp"
        />
      </div>

      <CustomButton
        endIcon={<ArrowForwardIcon />}
        className="mt-3"
        name="Continue"
        onClick={() => onNextClick("pay")}
        disabled={!isInputFilled}
      /> */}
     

{isMobileScreen ? (
  <>
    {/* Save delivery info but don't show Continue button */}
    <br/>
    <PaymentPage />
  </>
) : (<>
     <div
  className="box mt-3"
  style={{
    fontSize: "16px",
    lineHeight: "24px",
    color: "#000",
    fontFamily:"Roboto"
  }}
>
  By continuing, you agree to receive order updates via WhatsApp.
</div>
  <CustomButton
    endIcon={<ArrowForwardIcon />}
    className="mt-3"
    name="Continue"
    onClick={() => onNextClick("pay")}
    disabled={!isInputFilled || Boolean(pickupTimeError)}
  />
  </>
)}
      <CustomDialog
          title="Select Delivery Address"
          openDialog={openAddressPopup}
          handleCloseDialog={handleCloseAddressPopup}
          component={
              <DeliverAddress
                  isPopup={true}
                  onClose={handleCloseAddressPopup}
              />
          }
          fullMobileWidth={true}
/>
    </div>
    
  );
};
